import { amplitudeLib } from 'freedom-shared';
import { unref } from 'vue';
import { providerClassLib } from 'shared';

import type {
  PassengersDataSubmitProps,
  SavedPaxListOpenParams,
  SavedPaxEditClickParams,
  SavedPaxSaveClickParams,
} from '../analytics';

export const trySubmitPassengersData = (props: PassengersDataSubmitProps) => {
  amplitudeLib.logEvent('avfree_pass_continue_click', {
    source: props.source,
    is_charter: providerClassLib.isFunSun(props.providerClass ?? ''),
    ...(props.validationErrors && {
      validation_errors: props.validationErrors.map(err => unref(err.$message)),
      has_special_symbols: props.hasSpecialSymbolsInInitials,
    }),
  });
};

export const selectSavedPassenger = (providerClass?: string) => {
  amplitudeLib.logEvent('avfree_choose_pass_click', {
    is_charter: providerClassLib.isFunSun(providerClass ?? ''),
  });
};

export const savedPaxListOpen = (params: SavedPaxListOpenParams) => {
  amplitudeLib.logEvent('avfree_pass_list_open', {
    is_charter: providerClassLib.isFunSun(params.providerClass ?? ''),
    key: params.key,
  });
};

const getSavedPaxEditPayload = (params: SavedPaxEditClickParams) => {
  return {
    full_name: `${params.passenger.lastName} ${params.passenger.firstName}`,
    index: params.index,
    is_charter: providerClassLib.isFunSun(params.providerClass ?? ''),
  };
};

export const savedPaxEditClick = (params: SavedPaxEditClickParams) => {
  const payload = getSavedPaxEditPayload(params);
  amplitudeLib.logEvent('avfree_pax_edit_open', payload);
};

const getSavedPaxSavePayload = (params: SavedPaxSaveClickParams) => {
  const payload: {
    has_error: boolean;
    full_name?: string;
    is_charter?: boolean;
  } = {
    has_error: params.has_error,
    is_charter: providerClassLib.isFunSun(params.providerClass ?? ''),
  };

  if (params.firstName && params.lastName) {
    payload.full_name = `${params.lastName} ${params.firstName}`;
  }

  return payload;
};

export const savedPaxSaveClick = (params: SavedPaxSaveClickParams) => {
  const payload = getSavedPaxSavePayload(params);
  amplitudeLib.logEvent('avfree_pax_save_click', payload);
};

export const addNewPaxClick = (providerClass?: string) => {
  amplitudeLib.logEvent('avfree_pax_add_click', {
    is_charter: providerClassLib.isFunSun(providerClass ?? ''),
  });
};
